import FullmaktSkjema from "./FullmaktSkjema";
import { useManuellRegistreringContext } from "../../ManuellRegistreringsflyt/useManuellRegistreringContext";

export function ManuellFullmakt() {
  const { integrasjonsPartner, kontaktInfo, previousStep, nextStep, reset } =
    useManuellRegistreringContext();

  if (!integrasjonsPartner || !kontaktInfo) {
    return reset();
  }

  return (
    <FullmaktSkjema
      integrasjonsPartner={integrasjonsPartner}
      registrerendeBedrift={kontaktInfo}
      goBack={previousStep}
      accept={nextStep}
    />
  );
}
